import { AxiosError } from 'axios';

// Attachment/exercise endpoints return `{ "message": "..." }` on 400 with
// text that's meant to be shown to the user as-is (see the backend's
// integration guide) — not an i18n key, so callers render it as plain text.
function getAxiosErrorMessage(error: unknown, fallback: string): string {
  const axiosError = error as AxiosError<{ message?: string }>;
  return axiosError.response?.data?.message || fallback;
}

export { getAxiosErrorMessage };
